import React, {Component} from 'react'
import {Alert, Divider, Icon, Input} from 'antd'
import OrderItemDetailsContainer from './details/OrderItemDetailsContainer'
import OrderItemTypeContainer from './type/OrderItemTypeContainer'
import PropTypes from 'prop-types'
import changeQuerySearch from '../../../helpers/rounting/changeQuerySearch'
import OrderHistoriesContainer from './histories/OrderHistoriesContainer'
import {getDetailBarcode,getHistoryOrder} from "../../../services/api/3dApi"

class OrderItemPage extends Component {
    state = {
        template: {},
        current: this.props.currentTemplate,
        loading: false,
        error: '',
        histories: []
    }

    componentDidMount() {
        this._fetchOrderDetail(this.state.current)
    }

    _input = React.createRef()
    _timeOut = null

    _handleChange = e => {
        const {value} = e.target
        const check = /^#\d+_\d+$/.test(value)
        
        this.setState({
            current: value,
        })

        if(!check) {
            return this.setState({
                error: 'Item không đúng định dạng.',
                template: {}
            })
        }

        if (this._timeOut) clearTimeout(this._timeOut)

        this._timeOut = setTimeout(() => {
            this._fetchOrderDetail(value)
        }, 0)
    }

    _fetchOrderDetail = async (template) => {
        try {
            if (!template.trim()) {
                return
            }

            this.setState({
                loading: true,
                error: '',
            })

            const {data: response} = await getDetailBarcode(template.trim().replace(/^#/, ''))

            const {data, success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                template: data,
                loading: false,
                error: '',
            }, () => {
                this._fetchOrderHistory(data._id)
            })

        } catch (e) {
            this.setState({
                error: e.message,
                loading: false,
                template: {},
            })
        }
    }

    _fetchOrderHistory = async (orderID) => {
        try {

            this.setState({
                loading: true,
                error: '',
            })

            const {data: response} = await getHistoryOrder(orderID)

            const {data, success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                histories: data,
                loading: false,
                error: '',
            })

        } catch (e) {
            this.setState({
                error: e.message,
                loading: false,
                histories: {},
            })
        }
    }

    _afterUpdateBasketSuccess = () => {
        this.setState({
            current: '',
            template: {},
        }, () => {
            this._input.current.focus()
        })
    }

    _clearInput = () => {
        this.setState({
            current: '',
            template: {},
        }, () => {
            changeQuerySearch({template: ''}, true)
            this._input.current.focus()
        })
    }

    render() {
        const {error, template, current, histories, loading} = this.state
        const {type, _id, failed_partials = [], basket_number} = template

        return (
            <div className='OrderItemPage py-3 fs-20'>
                <div className='bg-light p-3 mb-3'>
                    <h1>Nhập mã đơn</h1>

                    <div className='mb-3'>
                        <div className='position-relative'>
                            <Input onChange={this._handleChange} size='large' autoFocus={true} ref={this._input}
                                   value={current} className='InputSearch' disabled={loading}/>

                            <div className='position-absolute IconClear'>
                                <Icon type="close-circle" theme="filled" onClick={this._clearInput}/>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    error &&
                    <Alert message='ERROR:' description={error} type='error' showIcon/>
                }

                {
                    _id &&
                    <div>
                        <Divider orientation='left'><h3>Thông tin đơn</h3></Divider>

                        <div className='mb-5'>
                            <OrderItemDetailsContainer template={template} onCleanPage={this._clearInput}/>
                        </div>

                        <Divider orientation='left'><h3>Đánh dấu mảnh lỗi</h3></Divider>

                        <OrderItemTypeContainer type={type} orderId={_id} failedPartials={failed_partials}
                                                basketNumber={basket_number}
                                                onUpdateBasketSuccess={this._afterUpdateBasketSuccess}/>

                        {
                            Array.isArray(histories) && histories.length > 0 &&
                            <>
                                <Divider orientation='left'><h3>Lịch sử</h3></Divider>

                                <OrderHistoriesContainer histories={histories}/>
                            </>
                        }
                    </div>
                }
            </div>
        )
    }
}

OrderItemPage.propTypes = {
    currentTemplate: PropTypes.string.isRequired,
}

export default OrderItemPage
